var _module_exports ="<div class=\"col-sm-12 margin-md-top\">\n    <div class=\"box padding-lg no-margin\">\n        <h3>No Active Aric Process</h3>\n    </div>\n</div>";;
var path = '/app/Main/aric/withNoActiveProcess.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;